export const ETHNICITIES = [
  "American Indian or Alaska Native",
  "Asian",
  "Black or African American",
  "Hispanic or Latino",
  "Middle Eastern or North African",
  "Native Hawaiian or Pacific Islander",
  "White",
  "Two or More Races",
  "Other",
  "Prefer not to say"
];

export const EDUCATION_LEVELS = [
  "Less than High School",
  "High School Diploma or GED",
  "Some College, No Degree",
  "Associate Degree",
  "Bachelor's Degree",
  "Master's Degree",
  "Doctoral Degree (PhD, MD, JD, etc.)",
  "Professional Degree",
  "Prefer not to say"
];

export const GENDERS = ["Male", "Female", "Other"];

export const MILITARY_SERVICE_STATUSES = [
  "Active Service Member",
  "Previous Service Experience",
  "No Military Service",
  "Prefer not to say"
];

export const GENERATIONS = [
  "Silent Generation (1928-1945)",
  "Baby Boomers (1946-1964)",
  "Generation X (1965-1980)",
  "Millennials (1981-1996)",
  "Generation Z (1997-2012)"
];
